import React, { useState, useEffect } from 'react';
import Card from '../../../Shared/Components/Card/Card';

const OceanCleanup = ({ updateStats }) => {
    const [items, setItems] = useState([]);
    const [score, setScore] = useState(0);
    const [timeLeft, setTimeLeft] = useState(60);
    const [isPlaying, setIsPlaying] = useState(false);
    const [gameOver, setGameOver] = useState(false);

    const itemTypes = [
        { emoji: '🐢', category: 'marine', points: 10, label: 'Sea Turtle' },
        { emoji: '🐠', category: 'marine', points: 10, label: 'Fish' },
        { emoji: '🐙', category: 'marine', points: 10, label: 'Octopus' },
        { emoji: '🦀', category: 'marine', points: 10, label: 'Crab' },
        { emoji: '🗑️', category: 'trash', points: 20, label: 'Trash' },
        { emoji: '🥤', category: 'trash', points: 20, label: 'Plastic Cup' },
        { emoji: '🥫', category: 'trash', points: 20, label: 'Can' },
        { emoji: '🛢️', category: 'trash', points: 30, label: 'Oil Barrel' }
    ];

    useEffect(() => {
        if (isPlaying && timeLeft > 0) {
            const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
            return () => clearTimeout(timer);
        } else if (timeLeft === 0 && isPlaying) {
            endGame();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [timeLeft, isPlaying]);

    useEffect(() => {
        if (isPlaying) {
            const interval = setInterval(() => {
                spawnItem();
            }, 1500);
            return () => clearInterval(interval);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isPlaying]);

    const spawnItem = () => {
        const item = itemTypes[Math.floor(Math.random() * itemTypes.length)];
        const newItem = {
            ...item,
            id: Date.now(),
            left: Math.random() * 80 + 5
        };
        setItems(prev => [...prev, newItem]);

        // Remove item after animation
        setTimeout(() => {
            setItems(prev => prev.filter(i => i.id !== newItem.id));
        }, 4000);
    };

    const handleItemClick = (item) => {
        if (item.category === 'trash') {
            setScore(score + item.points);
            updateStats('itemsRecycled', 1);
        } else {
            setScore(Math.max(0, score - 5));
        }
        setItems(items.filter(i => i.id !== item.id));
    };

    const startGame = () => {
        setIsPlaying(true);
        setScore(0);
        setTimeLeft(60);
        setGameOver(false);
        setItems([]);
    };

    const endGame = () => {
        setIsPlaying(false);
        setGameOver(true);
        updateStats('gamesPlayed', 1);
    };

    return (
        <Card>
            <div style={{ padding: '32px' }}>
                <div style={{ textAlign: 'center', marginBottom: '32px' }}>
                    <h4 style={{ color: '#1f2937', marginBottom: '8px' }}>Ocean Cleanup</h4>
                    <p style={{ color: '#6b7280', margin: 0 }}>
                        Click on trash to clean the ocean, but don't click the marine life!
                    </p>
                </div>

                {/* Score and Timer */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: '16px',
                    marginBottom: '32px',
                    maxWidth: '400px',
                    margin: '0 auto 32px'
                }}>
                    <div style={{
                        background: '#f3f4f6',
                        borderRadius: '12px',
                        padding: '16px',
                        textAlign: 'center'
                    }}>
                        <div style={{ fontSize: '0.75rem', color: '#666', fontWeight: '600', marginBottom: '4px' }}>
                            SCORE
                        </div>
                        <div style={{ fontSize: '2rem', fontWeight: '700', color: '#4facfe' }}>
                            {score}
                        </div>
                    </div>
                    <div style={{
                        background: '#f3f4f6',
                        borderRadius: '12px',
                        padding: '16px',
                        textAlign: 'center'
                    }}>
                        <div style={{ fontSize: '0.75rem', color: '#666', fontWeight: '600', marginBottom: '4px' }}>
                            TIME
                        </div>
                        <div style={{
                            fontSize: '2rem',
                            fontWeight: '700',
                            color: timeLeft < 10 ? '#f5576c' : '#11998e'
                        }}>
                            {timeLeft}s
                        </div>
                    </div>
                </div>

                {/* Game Area */}
                <div style={{
                    position: 'relative',
                    width: '100%',
                    maxWidth: '800px',
                    height: '400px',
                    margin: '0 auto 32px',
                    background: 'linear-gradient(180deg, #4facfe 0%, #00f2fe 50%, #0077be 100%)',
                    borderRadius: '16px',
                    overflow: 'hidden',
                    boxShadow: '0 10px 40px rgba(79, 172, 254, 0.3)'
                }}>
                    {!isPlaying && !gameOver && (
                        <div style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            textAlign: 'center',
                            color: 'white',
                            zIndex: 10
                        }}>
                            <div style={{ fontSize: '4rem', marginBottom: '16px' }}>🌊</div>
                            <h3 style={{ marginBottom: '16px', textShadow: '0 2px 4px rgba(0, 0, 0, 0.2)' }}>
                                Ready to Clean the Ocean?
                            </h3>
                            <p style={{ marginBottom: '24px', opacity: 0.9 }}>
                                Click trash items to collect them, avoid marine life!
                            </p>
                        </div>
                    )}

                    {gameOver && (
                        <div style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            textAlign: 'center',
                            color: 'white',
                            zIndex: 10,
                            background: 'rgba(0, 0, 0, 0.3)',
                            padding: '40px',
                            borderRadius: '16px',
                            backdropFilter: 'blur(10px)'
                        }}>
                            <div style={{ fontSize: '4rem', marginBottom: '16px' }}>🏆</div>
                            <h3 style={{ marginBottom: '8px', textShadow: '0 2px 4px rgba(0, 0, 0, 0.2)' }}>
                                Game Over!
                            </h3>
                            <p style={{ fontSize: '2rem', fontWeight: '700', marginBottom: '16px' }}>
                                Score: {score}
                            </p>
                            <p style={{ opacity: 0.9 }}>
                                {score > 300 ? 'Amazing work!' : score > 150 ? 'Great job!' : 'Keep practicing!'}
                            </p>
                        </div>
                    )}

                    {/* Floating Items */}
                    {items.map(item => (
                        <div
                            key={item.id}
                            onClick={() => handleItemClick(item)}
                            style={{
                                position: 'absolute',
                                fontSize: '3rem',
                                cursor: 'pointer',
                                left: `${item.left}%`,
                                animation: 'float-down 4s linear',
                                transition: 'transform 0.1s ease',
                                zIndex: 5
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'scale(1.2)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'scale(1)';
                            }}
                            title={item.label}
                        >
                            {item.emoji}
                        </div>
                    ))}

                    {/* Wave decoration */}
                    <div style={{
                        position: 'absolute',
                        bottom: 0,
                        width: '100%',
                        height: '60px',
                        background: 'rgba(255, 255, 255, 0.1)',
                        borderRadius: '50% 50% 0 0'
                    }}></div>
                </div>

                <style>{`
                    @keyframes float-down {
                        0% {
                            top: -60px;
                            opacity: 0;
                        }
                        10% {
                            opacity: 1;
                        }
                        90% {
                            opacity: 1;
                        }
                        100% {
                            top: 100%;
                            opacity: 0;
                        }
                    }
                `}</style>

                {/* Controls */}
                <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
                    <button
                        onClick={startGame}
                        style={{
                            background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                            border: 'none',
                            borderRadius: '8px',
                            padding: '14px 32px',
                            color: 'white',
                            fontWeight: '600',
                            fontSize: '1rem',
                            cursor: 'pointer',
                            boxShadow: '0 4px 12px rgba(79, 172, 254, 0.3)',
                            transition: 'all 0.3s ease'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-2px)';
                            e.currentTarget.style.boxShadow = '0 6px 16px rgba(79, 172, 254, 0.4)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(79, 172, 254, 0.3)';
                        }}
                    >
                        {gameOver ? 'Play Again' : isPlaying ? 'Restart' : 'Start Game'}
                    </button>
                </div>

                {/* Legend */}
                <div style={{
                    marginTop: '32px',
                    padding: '20px',
                    background: '#f9fafb',
                    borderRadius: '12px',
                    borderLeft: '4px solid #4facfe'
                }}>
                    <h6 style={{ color: '#1f2937', marginBottom: '12px', fontSize: '0.95rem', fontWeight: '600' }}>
                        Scoring Guide
                    </h6>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '12px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <span style={{ fontSize: '1.5rem' }}>🗑️</span>
                            <span style={{ color: '#6b7280' }}>Trash: +20 points</span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <span style={{ fontSize: '1.5rem' }}>🛢️</span>
                            <span style={{ color: '#6b7280' }}>Oil: +30 points</span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <span style={{ fontSize: '1.5rem' }}>🐢</span>
                            <span style={{ color: '#6b7280' }}>Marine Life: -5 points</span>
                        </div>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default OceanCleanup;
